import { createContext, useContext, useState } from "react";
import { translations } from "../i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("ember-lang") || "en");
  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem("ember-lang", l);
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang: switchLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
